import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";

const logoEnums = {
  APP_ICON: "App Icon",
  LOGO: "Logo",
  SPLASH_SCREEN: "Splash Screen",
};

const RemoveLogo = ({
  isRemoveOpen,
  closeRemoveModal,
  deleteLogoCms,
  selectedImgUrl,
  selectedLogoType,
}) => {
  const handleDelete = async () => {
    deleteLogoCms();
    closeRemoveModal();
  };

  return (
    <Modal
      show={isRemoveOpen}
      onHide={closeRemoveModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Remove {logoEnums[selectedLogoType]}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <img src={selectedImgUrl} className="img-fluid mb-2" />
        </div>
        <div>Are you sure you want to remove this logo?</div>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Delete" callBack={handleDelete} />
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveLogo;
